import { jsx } from 'react/jsx-runtime';

const SvgRatingNeutralAlt = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M7.5 9.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM16.5 9.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM18 14H6v2h12v-2Z" }) }));

export { SvgRatingNeutralAlt as default };
//# sourceMappingURL=RatingNeutralAlt.es.js.map
